/* eslint-disable no-console,no-unused-vars,no-undef,max-len */
import React from 'react';
import { Link } from 'gatsby';
import { Sine, TimelineMax } from 'gsap';
import BatteryFeaturedImage from '../../../../images/ace-features/battery.svg';
import CoilFeaturedImage from '../../../../images/ace-features/coil.svg';
import CapacityFeaturedImage from '../../../../images/ace-features/capacity.svg';
import MicroUSBFeaturedImage from '../../../../images/ace-features/micro-usb.svg';
import './style.scss';
import getCloudinary from '../../../../utils/getCloudinary';

const MainIntroSlide = () => {
    let screenWidth = 0;
    if (typeof window !== 'undefined') {
        screenWidth = window.innerWidth
            || document.documentElement.clientWidth
            || document.body.clientWidth;
    }

    return (
        <div
            className="hero-swiper-slide main-intro-slide"
            style={{
                backgroundImage: `url("${getCloudinary().url(
                    'dashboard-uploads/sam_lisa_oil_xbcd22',
                    { width: screenWidth, crop: 'fit', fetch_format: 'auto' },
                )}")`,
            }}
        >
            <div className="image-dimmer">
                <div className="container">
                    <div
                        className="title is-size-3-touch is-size-3-desktop has-text-white is-spaced has-text-centered"
                    >
                        All new skincare and supplements!
                    </div>
                    <div
                        className="subtitle is-size-4-touch is-size-4-desktop has-text-white has-text-centered"
                    >
                        Join the millions of people around the world using CBD and be a better you
                    </div>
                    <div className="buttons-container">
                        <Link className="button is-large is-theme-success has-text-white has-text-weight-semibold" to="/shop">Shop Now</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

MainIntroSlide.propTypes = {};

export default MainIntroSlide;
